/**
 * Add to Cart Popup Handler
 * Prevents cart drawer from opening and shows custom popup instead
 */

(function() {
  'use strict';

  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    console.log('=== ADD TO CART POPUP INIT ===');
    
    // Only run on product pages
    if (!document.querySelector('xo-product[xo-product-id]')) {
      console.log('Not a product page, exiting');
      return;
    }
    
    console.log('Product page detected');
    
    // Test if popup elements exist
    const modal = document.querySelector('xo-modal[xo-name="add-to-cart-popup"]');
    const relatedSection = document.getElementById('add-to-cart-popup-related-products');
    const relatedContainer = relatedSection ? relatedSection.querySelector('.add-to-cart-popup__related-products') : null;
    
    console.log('Modal found:', !!modal);
    console.log('Related section found:', !!relatedSection);
    console.log('Related container found:', !!relatedContainer);
    
    if (!modal) {
      console.error('WARNING: Add to cart popup modal not found in DOM!');
    }
    if (!relatedSection) {
      console.error('WARNING: Related products section not found in DOM!');
    }
    if (!relatedContainer) {
      console.error('WARNING: Related products container not found in DOM!');
    }

    // Check if product has cross_sell products or handig_mee_te_bestellen
    function hasCrossSellProducts() {
      // Check if there's a cross-sell section visible
      const crossSellSection = document.querySelector('.product-content-new__cross-sell');
      if (crossSellSection && crossSellSection.querySelector('.product-content-new__cross-sell-item')) {
        return true;
      }
      
      // Check product data for cross_sell or handig_mee_te_bestellen metafield
      const productElement = document.querySelector('xo-product[xo-product-id]');
      if (productElement) {
        const productDataElement = productElement.querySelector('xo-product-data script[type="application/json"]');
        if (productDataElement) {
          try {
            const data = JSON.parse(productDataElement.textContent);
            
            // Check for cross_sell
            if (data.metafields && data.metafields.custom && data.metafields.custom.cross_sell) {
              const crossSell = data.metafields.custom.cross_sell.value || data.metafields.custom.cross_sell;
              if (crossSell && (Array.isArray(crossSell) ? crossSell.length > 0 : crossSell)) {
                return true;
              }
            }
            
            // Also check for handig_mee_te_bestellen
            if (data.metafields && data.metafields.custom && data.metafields.custom.handig_mee_te_bestellen) {
              const handigMee = data.metafields.custom.handig_mee_te_bestellen;
              if (handigMee && (Array.isArray(handigMee) ? handigMee.length > 0 : handigMee)) {
                console.log('Product has handig_mee_te_bestellen products');
                return true;
              }
            }
          } catch (e) {
            console.error('Error parsing product data:', e);
          }
        }
      }
      
      return false;
    }

    // Check if this is a battery product
    function isBatteryProduct() {
      // Check if there's a battery subscription form
      if (document.querySelector('.battery-subscription-form')) {
        return true;
      }
      
      // Check template name from body or meta tags
      const body = document.body;
      if (body && (body.classList.contains('template-product-batterij') || 
                   body.getAttribute('data-template') === 'product.batterij')) {
        return true;
      }
      
      // Check product type or handle
      const productElement = document.querySelector('xo-product[xo-product-id]');
      if (productElement) {
        const productDataElement = productElement.querySelector('xo-product-data script[type="application/json"]');
        if (productDataElement) {
          try {
            const data = JSON.parse(productDataElement.textContent);
            const productType = (data.product_type || '').toLowerCase();
            const handle = (data.handle || '').toLowerCase();
            if (productType.includes('batterij') || productType.includes('battery') ||
                handle.includes('batterij') || handle.includes('battery')) {
              return true;
            }
          } catch (e) {
            console.error('Error parsing product data:', e);
          }
        }
      }
      
      return false;
    }

    // Only prevent cart drawer if product has cross_sell products
    // Battery products and products without cross_sell should open cart drawer normally
    const hasCrossSellValue = hasCrossSellProducts();
    const isBattery = isBatteryProduct();
    
    // Only show popup (prevent cart drawer) if product has cross_sell products
    // Battery products and products without cross_sell should open cart drawer
    if (hasCrossSellValue) {
      console.log('Product has cross_sell products - preventing cart drawer, showing popup');
      
      // Disable cart drawer opening for add-to-cart buttons on PDP with cross_sell
      // Target specifically the button in product-content-new
      const productContentNew = document.querySelector('.product-content-new');
      if (productContentNew) {
        const cartAddButton = productContentNew.querySelector('xo-cart-add');
        if (cartAddButton) {
          // Prevent cart drawer from opening
          cartAddButton.setAttribute('xo-cart-opened', 'false');
        }
      }

      // Also check other product page layouts
      const cartAddButtons = document.querySelectorAll('xo-cart-add');
      cartAddButtons.forEach(function(button) {
        // Check if this is on a product page (not in a collection/product card)
        const isOnProductPage = button.closest('.main-product') || 
                                button.closest('.xo-product-info-content');
        
        if (isOnProductPage && !button.closest('.product-content-new')) {
          // Prevent cart drawer from opening (product-content-new is handled above)
          button.setAttribute('xo-cart-opened', 'false');
        }
      });
    } else {
      // No cross_sell or battery product - allow cart drawer to open normally
      console.log('Product has no cross_sell or is battery product - allowing cart drawer to open');
    }

    // Listen for cart add success events
    document.addEventListener('xo-cart/addCartSuccess', handleCartAddSuccess);
    
    // Also listen for xoStore cart updates as fallback
    let lastCartSize = 0;
    if (window.xoStore && typeof window.xoStore.subscribe === 'function') {
      window.xoStore.subscribe('xo-cart', function(state) {
        // Check if cart size increased (product was added)
        const currentCartSize = state && state.size ? state.size : 0;
        if (currentCartSize > lastCartSize && !state.addErrorMessage) {
          lastCartSize = currentCartSize;
          // Small delay to ensure product data is available
          setTimeout(function() {
            handleCartAddSuccess();
          }, 200);
        } else if (state && state.isAdded && !state.addErrorMessage) {
          // Fallback: check isAdded flag
          setTimeout(function() {
            handleCartAddSuccess();
          }, 200);
        }
      });
      
      // Initialize lastCartSize
      const currentState = window.xoStore.get('xo-cart');
      if (currentState && currentState.size) {
        lastCartSize = currentState.size;
      }
    }
    
    // Also listen directly to the cart-add button click to catch it early
    // Only set flag if product has cross_sell
    if (hasCrossSellValue) {
      const productContentNewButton = document.querySelector('.product-content-new xo-cart-add');
      if (productContentNewButton) {
        productContentNewButton.addEventListener('click', function(e) {
          // Set a flag to show popup after cart add (only if cross_sell exists)
          window.shouldShowAddToCartPopup = true;
        });
      }
    }
  }

  function handleCartAddSuccess() {
    // Only show popup if flag is set (to avoid showing on other cart updates)
    if (!window.shouldShowAddToCartPopup) {
      return;
    }
    
    // Reset flag
    window.shouldShowAddToCartPopup = false;
    
    // Get the last added product from cart
    fetch('/cart.js')
      .then(function(response) {
        return response.json();
      })
      .then(function(cart) {
        if (cart.items && cart.items.length > 0) {
          const lastItem = cart.items[cart.items.length - 1];
          showPopup(lastItem);
        }
      })
      .catch(function(error) {
        console.error('Error fetching cart:', error);
      });
  }

  function showPopup(productItem) {
    const modal = document.querySelector('xo-modal[xo-name="add-to-cart-popup"]');
    if (!modal) {
      console.error('Add to cart popup modal not found');
      return;
    }

    console.log('=== SHOW POPUP START ===');
    console.log('Product item:', productItem);

    // Hide related section initially
    const relatedSection = document.getElementById('add-to-cart-popup-related-products');
    if (relatedSection) {
      relatedSection.style.display = 'none';
    }

    // Populate product info
    populateProductInfo(productItem);
    
    // Get and populate related products from metafield
    // Wait for products to load before opening modal
    // IMPORTANT: Always use the current page product, not the cart item product_id
    console.log('Calling getRelatedProducts (using current page product, not cart item)');
    getRelatedProducts().then(function(relatedProducts) {
      console.log('=== RELATED PRODUCTS PROMISE RESOLVED ===');
      console.log('Related products loaded:', relatedProducts);
      console.log('Number of products:', relatedProducts ? relatedProducts.length : 0);
      
      if (relatedProducts && relatedProducts.length > 0) {
        console.log('Populating related products...');
        populateRelatedProducts(relatedProducts);
      } else {
        console.log('No related products found, keeping section hidden');
        if (relatedSection) {
          relatedSection.style.display = 'none';
        }
      }
      
      // Now open the modal after products are loaded
      console.log('Opening modal now...');
      openModalNow();
    }).catch(function(error) {
      console.error('=== ERROR IN RELATED PRODUCTS PROMISE ===');
      console.error('Error getting related products:', error);
      if (relatedSection) {
        relatedSection.style.display = 'none';
      }
      
      // Still open the modal even if there's an error
      console.log('Opening modal despite error...');
      openModalNow();
    });

    // Function to open modal using xoModal API
    function openModalNow() {
      function openModal() {
        if (window.xoModal && typeof window.xoModal.open === 'function') {
          try {
            window.xoModal.open('add-to-cart-popup');
            return true;
          } catch (error) {
            console.error('Error opening modal via xoModal:', error);
            return false;
          }
        }
        return false;
      }
      
      // Try to open immediately
      if (openModal()) {
        return;
      }
      
      // Wait for xoModal to be available (max 2 seconds)
      let attempts = 0;
      const maxAttempts = 40; // 2 seconds at 50ms intervals
      const checkModal = setInterval(function() {
        attempts++;
        if (openModal()) {
          clearInterval(checkModal);
        } else if (attempts >= maxAttempts) {
          // After timeout, try direct attribute as last resort
          clearInterval(checkModal);
          modal.setAttribute('xo-active', 'true');
          
          // Manually set styles as fallback
          setTimeout(function() {
            if (modal.getAttribute('xo-active') === 'true') {
              modal.style.visibility = 'visible';
              modal.style.opacity = '1';
              modal.style.zIndex = '10000';
              modal.style.pointerEvents = 'auto';
            }
          }, 100);
        }
      }, 50);
    }
  }

  function populateProductInfo(productItem) {
    const productInfoContainer = document.getElementById('add-to-cart-popup-product-info');
    if (!productInfoContainer) return;

    // Handle image - can be string or object
    let imageUrl = '';
    if (productItem.image) {
      if (typeof productItem.image === 'string') {
        imageUrl = productItem.image;
      } else if (productItem.image.src) {
        imageUrl = productItem.image.src;
      } else if (productItem.image.url) {
        imageUrl = productItem.image.url;
      }
    }
    
    // Format image URL for proper sizing
    if (imageUrl) {
      // Remove existing size parameters and add new one
      imageUrl = imageUrl.split('?')[0];
      // Add size parameter for 200x200
      if (imageUrl.includes('cdn.shopify.com')) {
        imageUrl = imageUrl.replace(/\.(jpg|jpeg|png|webp)/i, '_200x200.$1');
      }
    }
    
    const productTitle = productItem.product_title || productItem.title || '';
    const variantTitle = productItem.variant_title;
    const price = formatMoney(productItem.final_price || productItem.price || 0);

    let displayTitle = productTitle;
    if (variantTitle && variantTitle !== 'Default Title') {
      displayTitle += ' - ' + variantTitle;
    }

    productInfoContainer.innerHTML = `
      ${imageUrl ? `<img src="${escapeHtml(imageUrl)}" alt="${escapeHtml(productTitle)}" class="add-to-cart-popup__added-product-image" loading="lazy">` : '<div class="add-to-cart-popup__added-product-image add-to-cart-popup__added-product-image--placeholder"></div>'}
      <div class="add-to-cart-popup__added-product-info">
        <div class="add-to-cart-popup__added-header">
          <div class="add-to-cart-popup__added-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M20 6L9 17L4 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <span class="add-to-cart-popup__added-text">Toegevoegd</span>
        </div>
        <div class="add-to-cart-popup__added-product-title">${escapeHtml(displayTitle)}</div>
        <div class="add-to-cart-popup__added-product-price">${price}</div>
      </div>
    `;
  }

  function getRelatedProducts() {
    
    // ALWAYS get metafield from current product data on the page (not from cart item)
    const productElement = document.querySelector('xo-product[xo-product-id]');
    let relatedProductIds = null;
    
    if (productElement) {
      // xo-product-data wraps the script in <template> - template content is not in the DOM tree,
      // so we must read from template.content
      const productDataWrapper = productElement.querySelector('xo-product-data');
      let scriptEl = null;
      if (productDataWrapper) {
        const template = productDataWrapper.querySelector('template');
        if (template && template.content) {
          scriptEl = template.content.querySelector('script[type="application/json"]');
        }
        if (!scriptEl) {
          scriptEl = productDataWrapper.querySelector('script[type="application/json"]');
        }
      }
      if (scriptEl) {
        try {
          const data = JSON.parse(scriptEl.textContent);
          console.log('Product data:', data);
          console.log('Product ID:', data.id);
          console.log('Product handle:', data.handle);
          
          if (data.metafields && data.metafields.custom && data.metafields.custom.handig_mee_te_bestellen) {
            relatedProductIds = data.metafields.custom.handig_mee_te_bestellen;
            console.log('Found handig_mee_te_bestellen in product data:', relatedProductIds);
          } else {
            console.log('No handig_mee_te_bestellen metafield found in product data');
            console.log('Metafields available:', data.metafields);
          }
        } catch (e) {
          console.error('Error parsing product data:', e);
        }
      }
      // Fallback: read from our explicit script (template content may not be queryable in some setups)
      if (!relatedProductIds) {
        const pageProductId = productElement.getAttribute('xo-product-id');
        const fallbackScript = document.querySelector('script#product-data-handig-mee-te-bestellen[data-product-id="' + pageProductId + '"]');
        if (fallbackScript) {
          try {
            relatedProductIds = JSON.parse(fallbackScript.textContent.trim());
            if (relatedProductIds && relatedProductIds.length > 0) {
              console.log('Found handig_mee_te_bestellen via fallback script:', relatedProductIds);
            }
          } catch (e) {
            console.error('Error parsing fallback product data:', e);
          }
        }
      }
      if (!relatedProductIds && !scriptEl) {
        console.log('No xo-product-data script found (checked template and direct child)');
      }
    } else {
      console.log('No xo-product element found');
    }
    
    // Return the fetched products (or empty array if none found)
    console.log('Fetching related products:', relatedProductIds);
    return fetchRelatedProducts(relatedProductIds);
  }
  
  function fetchRelatedProducts(relatedProductIds) {
    if (!relatedProductIds) {
      console.log('No related product IDs provided');
      return Promise.resolve([]);
    }
    
    // Handle if it's not an array (might be a single product reference)
    if (!Array.isArray(relatedProductIds)) {
      relatedProductIds = [relatedProductIds];
    }
    
    if (relatedProductIds.length === 0) {
      console.log('Empty related products array');
      return Promise.resolve([]);
    }
    
    console.log('Fetching ' + relatedProductIds.length + ' related products');
    
    // Fetch product data for each related product
    return Promise.all(
      relatedProductIds.map(function(productRef, index) {
        let productHandle = null;
        
        // Handle different formats: handle string, product object, or ID
        if (typeof productRef === 'string') {
          // It's a handle
          productHandle = productRef;
        } else if (typeof productRef === 'number') {
          // It's an ID - try to fetch by ID
          productHandle = productRef;
        } else if (productRef && typeof productRef === 'object') {
          // It's a product object - extract handle or ID (prefer handle)
          productHandle = productRef.handle || productRef.id;
        }
        
        if (!productHandle) {
          console.log('No product handle found for product ref:', productRef);
          return Promise.resolve(null);
        }
        
        // Try fetching by handle first (preferred), then by ID
        const productUrl = '/products/' + productHandle + '.js';
        console.log('Fetching product:', productUrl);
        
        return fetch(productUrl)
          .then(function(response) {
            if (!response.ok) {
              console.error('Failed to fetch product:', productHandle, 'Status:', response.status);
              return null;
            }
            return response.json();
          })
          .then(function(product) {
            console.log('Successfully fetched product:', product ? product.title : 'null');
            return product;
          })
          .catch(function(error) {
            console.error('Error fetching related product:', productHandle, error);
            return null;
          });
      })
    ).then(function(products) {
      const validProducts = products.filter(function(p) { return p !== null; });
      console.log('Fetched ' + validProducts.length + ' valid products out of ' + products.length);
      return validProducts;
    });
  }

  function getProductHandle(productId) {
    // Try to get handle from current product data
    const productElement = document.querySelector('xo-product[xo-product-id]');
    if (productElement) {
      // Try xo-product-data first
      const productDataElement = productElement.querySelector('xo-product-data script[type="application/json"]');
      if (productDataElement) {
        try {
          const data = JSON.parse(productDataElement.textContent);
          if (data.handle) {
            return data.handle;
          }
        } catch (e) {
          console.error('Error parsing product data:', e);
        }
      }
      
      // Fallback: try other JSON scripts
      const productData = productElement.querySelector('script[type="application/json"]');
      if (productData) {
        try {
          const data = JSON.parse(productData.textContent);
          if (data.handle) {
            return data.handle;
          }
        } catch (e) {
          console.error('Error parsing product data:', e);
        }
      }
    }
    
    // Fallback: try to get from URL
    const pathParts = window.location.pathname.split('/');
    if (pathParts[pathParts.length - 1]) {
      return pathParts[pathParts.length - 1];
    }
    
    return productId;
  }

  function populateRelatedProducts(products) {
    console.log('=== POPULATE RELATED PRODUCTS START ===');
    console.log('Products to populate:', products);
    
    const relatedSection = document.getElementById('add-to-cart-popup-related-products');
    
    if (!relatedSection) {
      console.error('Related section element not found!');
      return;
    }
    
    console.log('Related section found:', relatedSection);
    
    const relatedProductsContainer = relatedSection.querySelector('.add-to-cart-popup__related-products');
    
    if (!relatedProductsContainer) {
      console.error('Related products container not found!');
      return;
    }
    
    console.log('Related products container found:', relatedProductsContainer);
    
    if (products.length === 0) {
      console.log('No products to display, hiding section');
      relatedSection.style.display = 'none';
      return;
    }

    console.log('Generating HTML for', products.length, 'products');
    relatedProductsContainer.innerHTML = products.map(function(product) {
      // Handle image URL - can be string or object
      let imageUrl = '';
      if (product.featured_image) {
        if (typeof product.featured_image === 'string') {
          imageUrl = product.featured_image;
        } else if (product.featured_image.src) {
          imageUrl = product.featured_image.src;
        } else if (product.featured_image.url) {
          imageUrl = product.featured_image.url;
        }
      } else if (product.images && product.images.length > 0) {
        const firstImage = product.images[0];
        if (typeof firstImage === 'string') {
          imageUrl = firstImage;
        } else if (firstImage.src) {
          imageUrl = firstImage.src;
        } else if (firstImage.url) {
          imageUrl = firstImage.url;
        }
      }
      
      // Format image URL for proper sizing (Shopify CDN)
      if (imageUrl) {
        // Remove existing size parameters
        imageUrl = imageUrl.split('?')[0];
        // Add size parameter for 300x300
        if (imageUrl.includes('cdn.shopify.com') || imageUrl.includes('shopifycdn.com')) {
          imageUrl = imageUrl.replace(/\.(jpg|jpeg|png|webp)/i, '_300x300.$1');
        }
      }
      
      const title = product.title || '';
      const price = formatMoney(product.price || 0);
      const available = product.available !== false && 
                        product.variants && 
                        product.variants.length > 0 && 
                        product.variants[0].available !== false;
      const variantId = product.variants && product.variants[0] ? product.variants[0].id : null;
      const productUrl = '/products/' + (product.handle || product.id);

      return `
        <div class="add-to-cart-popup__related-product">
          <div class="xo-product-card xo-product-card--radius add-to-cart-popup__product-card">
            <div class="xo-product-card__header">
              ${!available ? '<span class="xo-product-card__badge add-to-cart-popup__sold-out-badge">Sold out</span>' : ''}
              <a href="${productUrl}" aria-label="${escapeHtml(title)}" class="xo-product-card__image-link">
                <div class="xo-product-card__media" style="aspect-ratio: 1; background: #f5f5f5;">
                  ${imageUrl ? `<img src="${escapeHtml(imageUrl)}" alt="${escapeHtml(title)}" loading="lazy" width="300" height="300" style="width:100%;height:100%;object-fit:cover;">` : '<div style="width:100%;height:100%;background:#e8e8e8;"></div>'}
                </div>
              </a>
            </div>
            <div class="xo-product-card__information add-to-cart-popup__card-info">
              <div class="xo-product-card__title-wrapper">
                <a href="${productUrl}" class="xo-product-card__title">${escapeHtml(title)}</a>
              </div>
              <div class="xo-product-card__price-badge">
                <div class="xo-product-card__price">
                  <div class="xo-product-card__price-inner">${price} EUR</div>
                </div>
              </div>
              ${available && variantId ? `
                <div class="xo-product-card__add-to-cart-title add-to-cart-popup__add-wrap">
                  <button type="button" class="add-to-cart-popup__quick-add xo-product-card__custom-cart-icon" data-variant-id="${variantId}" data-product-id="${product.id}" aria-label="Add to cart">
                <svg xmlns="http://www.w3.org/2000/svg" width="1.6rem" viewBox="0 0 16 16" fill="none">
                          <g clip-path="url(#clip0_8646_51843)">
                            <path d="M14 4H12C12 2.93913 11.5786 1.92172 10.8284 1.17157C10.0783 0.421427 9.06087 0 8 0C6.93913 0 5.92172 0.421427 5.17157 1.17157C4.42143 1.92172 4 2.93913 4 4H2C1.46957 4 0.960859 4.21071 0.585786 4.58579C0.210714 4.96086 0 5.46957 0 6L0 12.6667C0.00105857 13.5504 0.352588 14.3976 0.97748 15.0225C1.60237 15.6474 2.4496 15.9989 3.33333 16H12.6667C13.5504 15.9989 14.3976 15.6474 15.0225 15.0225C15.6474 14.3976 15.9989 13.5504 16 12.6667V6C16 5.46957 15.7893 4.96086 15.4142 4.58579C15.0391 4.21071 14.5304 4 14 4ZM8 1.33333C8.70724 1.33333 9.38552 1.61428 9.88562 2.11438C10.3857 2.61448 10.6667 3.29276 10.6667 4H5.33333C5.33333 3.29276 5.61428 2.61448 6.11438 2.11438C6.61448 1.61428 7.29276 1.33333 8 1.33333ZM14.6667 12.6667C14.6667 13.1971 14.456 13.7058 14.0809 14.0809C13.7058 14.456 13.1971 14.6667 12.6667 14.6667H3.33333C2.8029 14.6667 2.29419 14.456 1.91912 14.0809C1.54405 13.7058 1.33333 13.1971 1.33333 12.6667V6C1.33333 5.82319 1.40357 5.65362 1.5286 5.5286C1.65362 5.40357 1.82319 5.33333 2 5.33333H4V6.66667C4 6.84348 4.07024 7.01305 4.19526 7.13807C4.32029 7.2631 4.48986 7.33333 4.66667 7.33333C4.84348 7.33333 5.01305 7.2631 5.13807 7.13807C5.2631 7.01305 5.33333 6.84348 5.33333 6.66667V5.33333H10.6667V6.66667C10.6667 6.84348 10.7369 7.01305 10.8619 7.13807C10.987 7.2631 11.1565 7.33333 11.3333 7.33333C11.5101 7.33333 11.6797 7.2631 11.8047 7.13807C11.9298 7.01305 12 6.84348 12 6.66667V5.33333H14C14.1768 5.33333 14.3464 5.40357 14.4714 5.5286C14.5964 5.65362 14.6667 5.82319 14.6667 6V12.6667Z" fill="currentColor"></path>
                          </g>
                        </svg>
                    <span class="xo-product-card__custom-cart-icon-plus">
                      <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 17 17" fill="none"><path d="M16.2917 7.79167H9.20833V0.708333C9.20833 0.520472 9.13371 0.340304 9.00087 0.207466C8.86803 0.0746278 8.68786 0 8.5 0C8.31214 0 8.13197 0.0746278 7.99913 0.207466C7.86629 0.340304 7.79167 0.520472 7.79167 0.708333V7.79167H0.708333C0.520472 7.79167 0.340304 7.86629 0.207466 7.99913C0.0746278 8.13197 0 8.31214 0 8.5C0 8.68786 0.0746278 8.86803 0.207466 9.00087C0.340304 9.13371 0.520472 9.20833 0.708333 9.20833H7.79167V16.2917C7.79167 16.4795 7.86629 16.6597 7.99913 16.7925C8.13197 16.9254 8.31214 17 8.5 17C8.68786 17 8.86803 16.9254 9.00087 16.7925C9.13371 16.6597 9.20833 16.4795 9.20833 16.2917V9.20833H16.2917C16.4795 9.20833 16.6597 9.13371 16.7925 9.00087C16.9254 8.86803 17 8.68786 17 8.5C17 8.31214 16.9254 8.13197 16.7925 7.99913C16.6597 7.86629 16.4795 7.79167 16.2917 7.79167Z" fill="currentColor"/></svg>
                    </span>
                  </button>
                </div>
              ` : `
                <div class="xo-product-card__add-to-cart-title add-to-cart-popup__add-wrap">
                  <span class="add-to-cart-popup__quick-add xo-product-card__custom-cart-icon xo-product-card__icon--sold-out" aria-hidden="true">
                 <svg xmlns="http://www.w3.org/2000/svg" width="1.6rem" viewBox="0 0 16 16" fill="none">
                          <g clip-path="url(#clip0_8646_51843)">
                            <path d="M14 4H12C12 2.93913 11.5786 1.92172 10.8284 1.17157C10.0783 0.421427 9.06087 0 8 0C6.93913 0 5.92172 0.421427 5.17157 1.17157C4.42143 1.92172 4 2.93913 4 4H2C1.46957 4 0.960859 4.21071 0.585786 4.58579C0.210714 4.96086 0 5.46957 0 6L0 12.6667C0.00105857 13.5504 0.352588 14.3976 0.97748 15.0225C1.60237 15.6474 2.4496 15.9989 3.33333 16H12.6667C13.5504 15.9989 14.3976 15.6474 15.0225 15.0225C15.6474 14.3976 15.9989 13.5504 16 12.6667V6C16 5.46957 15.7893 4.96086 15.4142 4.58579C15.0391 4.21071 14.5304 4 14 4ZM8 1.33333C8.70724 1.33333 9.38552 1.61428 9.88562 2.11438C10.3857 2.61448 10.6667 3.29276 10.6667 4H5.33333C5.33333 3.29276 5.61428 2.61448 6.11438 2.11438C6.61448 1.61428 7.29276 1.33333 8 1.33333ZM14.6667 12.6667C14.6667 13.1971 14.456 13.7058 14.0809 14.0809C13.7058 14.456 13.1971 14.6667 12.6667 14.6667H3.33333C2.8029 14.6667 2.29419 14.456 1.91912 14.0809C1.54405 13.7058 1.33333 13.1971 1.33333 12.6667V6C1.33333 5.82319 1.40357 5.65362 1.5286 5.5286C1.65362 5.40357 1.82319 5.33333 2 5.33333H4V6.66667C4 6.84348 4.07024 7.01305 4.19526 7.13807C4.32029 7.2631 4.48986 7.33333 4.66667 7.33333C4.84348 7.33333 5.01305 7.2631 5.13807 7.13807C5.2631 7.01305 5.33333 6.84348 5.33333 6.66667V5.33333H10.6667V6.66667C10.6667 6.84348 10.7369 7.01305 10.8619 7.13807C10.987 7.2631 11.1565 7.33333 11.3333 7.33333C11.5101 7.33333 11.6797 7.2631 11.8047 7.13807C11.9298 7.01305 12 6.84348 12 6.66667V5.33333H14C14.1768 5.33333 14.3464 5.40357 14.4714 5.5286C14.5964 5.65362 14.6667 5.82319 14.6667 6V12.6667Z" fill="currentColor"></path>
                          </g>
                        </svg>
                    <span class="xo-product-card__custom-cart-icon-plus"><svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 17 17" fill="none"><path d="M16.2917 7.79167H9.20833V0.708333C9.20833 0.520472 9.13371 0.340304 9.00087 0.207466C8.86803 0.0746278 8.68786 0 8.5 0C8.31214 0 8.13197 0.0746278 7.99913 0.207466C7.86629 0.340304 7.79167 0.520472 7.79167 0.708333V7.79167H0.708333C0.520472 7.79167 0.340304 7.86629 0.207466 7.99913C0.0746278 8.13197 0 8.31214 0 8.5C0 8.68786 0.0746278 8.86803 0.207466 9.00087C0.340304 9.13371 0.520472 9.20833 0.708333 9.20833H7.79167V16.2917C7.79167 16.4795 7.86629 16.6597 7.99913 16.7925C8.13197 16.9254 8.31214 17 8.5 17C8.68786 17 8.86803 16.9254 9.00087 16.7925C9.13371 16.6597 9.20833 16.4795 9.20833 16.2917V9.20833H16.2917C16.4795 9.20833 16.6597 9.13371 16.7925 9.00087C16.9254 8.86803 17 8.68786 17 8.5C17 8.31214 16.9254 8.13197 16.7925 7.99913C16.6597 7.86629 16.4795 7.79167 16.2917 7.79167Z" fill="currentColor"/></svg></span>
                  </span>
                </div>
              `}
            </div>
          </div>
        </div>
      `;
    }).join('');

    console.log('HTML generated, adding event listeners...');
    
    // Add event listeners to quick add buttons (only actual buttons, not sold-out span)
    relatedProductsContainer.querySelectorAll('button.add-to-cart-popup__quick-add').forEach(function(button) {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        const variantId = button.getAttribute('data-variant-id');
        const productId = button.getAttribute('data-product-id');
        addProductToCart(variantId, productId, button);
      });
    });

    // Show the section
    console.log('Showing related section with display: block');
    relatedSection.style.display = 'block';
    console.log('=== POPULATE RELATED PRODUCTS COMPLETE ===');
  }

  function addProductToCart(variantId, productId, button) {
    if (!variantId) return;

    button.disabled = true;
    button.style.opacity = '0.6';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    })
    .then(function(response) {
      return response.json();
    })
    .then(function(item) {
      // Update cart count if needed
      if (window.xoStore && typeof window.xoStore.dispatch === 'function') {
        window.xoStore.dispatch('xo-cart', 'refresh');
      }
      
      // Show success feedback
      button.style.background = '#10a71f';
      setTimeout(function() {
        button.style.background = '#da1e28';
        button.disabled = false;
        button.style.opacity = '1';
      }, 1000);
    })
    .catch(function(error) {
      console.error('Error adding product to cart:', error);
      button.disabled = false;
      button.style.opacity = '1';
    });
  }

  function formatMoney(cents) {
    return new Intl.NumberFormat('nl-NL', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 2
    }).format(cents / 100);
  }

  function escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }
})();
